import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  formatWithoutCurrency,
  formatNumber,
  calcuTaxAmount,
} from '../../../helpers/helperFunction';

const OrderSummary = ({
  userDefaultCurrency,
  topUpAmount,
}) => {
  const [credit, setCredit] = useState(topUpAmount || 0);
  const [amountAfterTax, setAmountAfterTax] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const saleTax = 0.06;

  useEffect(() => {
    if (topUpAmount !== null) {
      setTopUpAmount();
    }
  }, [topUpAmount]);

  const setTopUpAmount = () => {
    setCredit(topUpAmount || 0);
    const amountAfter = topUpAmount;

    const { amountAfterTax, taxAmount } = calcuTaxAmount(amountAfter, saleTax);
    setAmountAfterTax(amountAfterTax || 0);
    setTaxAmount(taxAmount || 0);
  };

  return (
    <div className="OrderSummary">
      <div className="order-summary-wrapper">
        <p className="order-title">Top Up Summary</p>
        <table className="tax-amount w-100">
          <tbody>
            <tr>
              <td>Credit Amount</td>
              <td className="text-right">
                {userDefaultCurrency.symbol + ' ' + formatWithoutCurrency(credit)}
              </td>
            </tr>
            <tr>
              <td>Service Tax ({formatNumber(saleTax * 100, 2)}%)</td>
              <td className="text-right">
                {userDefaultCurrency.symbol + ' ' + formatWithoutCurrency(taxAmount)}
              </td>
            </tr>
          </tbody>
        </table>
        <table className="total-amount w-100">
          <tbody>
            <tr>
              <td>Payable Amount</td>
              <td className="text-right">
                {userDefaultCurrency.symbol + ' ' + formatWithoutCurrency(amountAfterTax)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { access_token } = state.auth;

  return {
    access_token,
  };
};

export default connect(mapStateToProps)(OrderSummary);
